import React from 'react';

import ProgConfigurationDetail from 'components/Tvendo/Distribution/Operations/ConfigProgramming/Detail/Show';

export default function () {
  return <ProgConfigurationDetail />;
}